import { Controller } from "stimulus"
import isMobile from '../helpers/isMobile';

export default class extends Controller {

  connect(event) {
    const statusSidebar = isMobile() ? 'hide' : this.getCookie('__sidebar-status');

    if (statusSidebar) {
      if (statusSidebar == "show") {
        this.showElements();
        return;
      }

      this.hideElements();
    }
  }

  hideElements(){
    document.querySelector('#sidebar-left').style.display = 'none';
    document.querySelector('#sidebar-left-min').style.display = '';
    document.querySelector('#link-hide').style.display = 'none';
  }

  showElements(){
    document.querySelector('#sidebar-left').style.display = '';
    document.querySelector('#sidebar-left-min').style.display = 'none';
    document.querySelector('#link-hide').style.display = '';
  }

  hide(event) {
    event.preventDefault()
    this.hideElements();
    this.createCookie('__sidebar-status', 'hide')
  }

  show(event) {
    event.preventDefault()
    this.showElements();
    this.createCookie('__sidebar-status', 'show')
  }

  getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  createCookie(name, status) {
    var mobile = /Mobi|Android/i.test(navigator.userAgent);
    if (! mobile) {
      document.cookie = name + " = " + status;
    }
  }
}
